module.exports = __webpack_public_path__ + "static/media/homen-rural.4cbb466b.png";